export default __webpack_public_path__ + "static/media/default.28f85c3284e512faf3f51c7865a5fde1.svg";